/** Session types for the DevTools staff SPA (board domain types live in src/shared). */

export interface UserObject {
  user_id: string;
  email?: string;
  name?: string;
  picture?: string;
  is_admin?: boolean;
  /** Active team from member JWT; required for tools-api boards/search. */
  team_id?: string;
  /** All teams the member belongs to (TeamSwitcher when length > 1). */
  team_ids?: string[];
}

export interface AuthStorage {
  token?: string;
  user?: UserObject;
}

export interface BeatlyAuthData {
  beatly_token: string;
  manager_email: string;
}

export interface GoogleUserInfo {
  email?: string;
  name?: string;
  picture?: string;
}

export class AuthApiError extends Error {
  status?: number;
  code?: string;

  constructor(message: string, status?: number, code?: string) {
    super(message);
    this.name = 'AuthApiError';
    this.status = status;
    this.code = code;
  }
}
